<template>
  <div>
    <a-list bordered item-layout="horizontal" :data-source="gatePassageway">
      <a-list-item
        slot="renderItem"
        slot-scope="item, index"
        @click="handleClick(item)"
      >
        <div class="list-content">
          <div class="list-content__title">设备位置：{{ item.name }}</div>
          <div class="list-content__title">设备别名：{{ item.code }}</div>
        </div>
      </a-list-item>
    </a-list>
    <div class="list-pagination">
      <a-pagination
        size="small"
        v-model="pageCurrent"
        :pageSize="pageSize"
        :total="totalCount"
        @change="pageChange"
      />
    </div>
    <div style="margin-bottom: 20px"></div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "",
  components: {},
  data() {
    return {
      pointId: undefined,
      gatePassageway: [],
      pageCurrent: 1,
      pageSize: 5,
      totalCount: 0,
    };
  },
  mounted() {
    const { alias, p } = this.$route.query;
    if (alias) {
      this.pointId = p;
      this.getGatePassageway(p);
    }
  },
  methods: {
    dateFormat(date) {
      return dayjs(date).format("YYYY/MM/DD");
    },
    async getGatePassageway(pointId) {
      const res = await this.$get(
        `/api/Gate/GetPassagewayPage?pointId=${pointId}&page=${this.pageCurrent}&pageSize=${this.pageSize}`
      );
      if (res.code === 200 && res.data) {
        this.pageCurrent = res.data.pageIndex;
        this.totalCount = res.data.totalCount;
        this.gatePassageway = [...res.data.items];
      }
    },
    pageChange(pageIndex) {
      this.pageCurrent = pageIndex;
      this.getGatePassageway(this.pointId);
    },
    handleClick(item) {
      const { id } = item;
      this.$router.push({
        path: "/gate/entrance",
        query: {
          alias: this.$route.query.alias,
          p: this.pointId,
          e: id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list-content {
  display: flex;
  flex-direction: column;
  &__title {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    line-height: 22px;
  }
  &__description {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    line-height: 22px;
  }
}
.list-pagination {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}
</style>
